module.exports = __webpack_public_path__ + "img/bank.d2d74bca.svg";